import src from "IMAGE";
export default { src, width: 475, height: 365, blurWidth: 0, blurHeight: 0};
